import React, { PureComponent } from 'react';
import classNames from 'classnames';
import { SubMenu as RcSubMenu } from '../rc-components/menu';
import MenuContext from './MenuContext';
class SubMenu extends PureComponent {
    constructor() {
        super(...arguments);
        this.onKeyDown = e => {
            this.subMenu.onKeyDown(e);
        };
        this.saveSubMenu = (subMenu) => {
            this.subMenu = subMenu;
        };
    }
    static get contextType() {
        return MenuContext;
    }
    render() {
        const { rootPrefixCls, className } = this.props;
        const { menuTheme } = this.context;
        return (React.createElement(RcSubMenu, Object.assign({}, this.props, { ref: this.saveSubMenu, popupClassName: classNames(`${rootPrefixCls}-${menuTheme}`, className) })));
    }
}
SubMenu.isSubMenu = 1;
export default SubMenu;
